import React, {Component, Fragment} from 'react';
import styles from './HeroSection.scss';
import classNames from 'classnames/bind';
import {observable, action} from 'mobx';
import {observer} from 'mobx-react';
import ScrollMagic from 'ScrollMagic';
import {HeroVideoBtn, ParticleCanvas} from '../../organisms';
import * as SceneEffects from '../../../../lib/functions/SceneEffects';

const cx = classNames.bind(styles);

class HeroSectionStore {
  @observable particleCount;

  @action setParticleCount = (paramParticleCount) => this.particleCount = paramParticleCount;
}

const heroSectionStore = new HeroSectionStore();

@observer
class HeroSection extends Component {
  heroSectionRef;
  heroBackdropRef;

  handleResize = () => {
    const particleCount = this.getParticleCount();
    (particleCount !== heroSectionStore.particleCount)
      && heroSectionStore.setParticleCount(particleCount);
  };

  getParticleCount = () => {
    return window.innerWidth > 768 ? 50 : 0;
  };

  handleSceneAnimation = () => {
    const heroController = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
      triggerElement: this.heroSectionRef,
      offset: window.innerHeight
    })
      .on('enter', () => {
        heroSectionStore.setParticleCount(0);
      })
      .on('leave', () => {
        heroSectionStore.setParticleCount(this.getParticleCount());
      })
      .addTo(heroController);
  };

  componentWillMount() {
    heroSectionStore.setParticleCount(this.getParticleCount());
  }

  componentDidMount() {
    const {
      handleSceneAnimation,
      handleResize,
      heroSectionRef,
      heroBackdropRef
    } = this;

    handleSceneAnimation();
    SceneEffects.whitening(heroSectionRef);
    SceneEffects.parallaxY(heroSectionRef, heroBackdropRef);
    window.addEventListener('resize', handleResize);
  }

  componentWillUnmount() {
    const {handleResize} = this;

    window.removeEventListener('resize', handleResize);
  }

  render() {
    return (
      <Fragment>
        <section className={cx('hero')} ref={ref => this.heroSectionRef = ref}>
          <div className={cx('hero-backdrop')} ref={ref => this.heroBackdropRef = ref} />
          <ParticleCanvas
            particleCount={heroSectionStore.particleCount}
          />
          <div className={cx('hero-foreground')}>
            <h1 lang='en-regular'>Breathe Easy</h1>
            <p><span lang='en-thin'>Awair</span>は空気中の有害物質を感知し、あなたの室内環境をより健康的で安全にするための空気モニターです。</p>
            <HeroVideoBtn
              youtubeVideoID='t23N4WJyCnY'
            />
          </div>
        </section>
      </Fragment>
    );
  }
}

export default HeroSection;


// WEBPACK FOOTER //
// ./src/app/components/organisms/HeroSection/HeroSection.js